import { GET_USER_LEADS_DOWNLOAD, GET_USER_LEADS_DOWNLOAD_ERR } from '../../actionTypes/leadsType'
import { downloadLeadsApi } from 'api/Api';
import axios from "axios";
import { accessToken } from 'api/Token'
export const getUserLeadsDownload = (payload) => async (dispatch) => {
    try {
        let results = await axios.get(`${downloadLeadsApi}/${payload.type}/${payload.search}/${payload.filterStartDate}/${payload.filterEndDate}/${payload.user_id}/${payload.searched}/${payload.page}`, await accessToken())
        let data = results && results.data
        dispatch({
            type: GET_USER_LEADS_DOWNLOAD,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_USER_LEADS_DOWNLOAD_ERR,
            payload: error.response,
        });
    }
};


